// extracted by mini-css-extract-plugin
export var auto = "_35-1";
export var spinner = "_35-0";